// extracted by mini-css-extract-plugin
module.exports = {"container":"OnlinePlayModal_container__3ymEw","error":"OnlinePlayModal_error__21CNP"};